// src/components/LAB/LABCalendarView.js
import React, { useState, useEffect } from 'react';
import runningIcon from '../../assets/icons/running.png';
import cyclingIcon from '../../assets/icons/cycling.png';
import swimIcon from '../../assets/icons/swim.png';
import strengthIcon from '../../assets/icons/strength.png';
import walkIcon from '../../assets/icons/walk.png';
import otherIcon from '../../assets/icons/other.png';
import challengeIcon from '../../assets/icons/challenge.png';
import { useTranslation } from '../../i18n';
import LABActivityModal from './LABActivityModal';
import LABCreateActivityModal from './LABCreateActivityModal';
import API_BASE_URL from '../../config/api';
const SPORT_ICONS_IMG = {
  correr: runningIcon,
  ciclismo: cyclingIcon,
  nadar: swimIcon,
  fuerza: strengthIcon,
  caminar: walkIcon,
  otro: otherIcon,
  competencia: challengeIcon,
};

const API = API_BASE_URL;

const SPORT_COLORS = {
  correr: '#9C27B0', ciclismo: '#4CAF50', nadar: '#2196F3',
  fuerza: '#f7941d', caminar: '#9ca3af', otro: '#6b7280'
};

const DAYS_I18N = {
  es: ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'],
  en: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
};
const MONTHS_I18N = {
  es: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
  en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
};
const SPORT_LABELS = {
  es: { correr:'correr', ciclismo:'ciclismo', nadar:'nadar', fuerza:'fuerza', caminar:'caminar' },
  en: { correr:'Running', ciclismo:'Cycling', nadar:'Swimming', fuerza:'Strength', caminar:'Walking' },
};

export default function LABCalendarView({ athleteId }) {
  const { language } = useTranslation();
  const lng = language === 'en' ? 'en' : 'es';
  const DAYS = DAYS_I18N[lng];
  const MONTHS = MONTHS_I18N[lng];
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth());
  const [activities, setActivities] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [createDate, setCreateDate] = useState(null);
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    if (!athleteId) return;
    const token = localStorage.getItem('token');
    const start = new Date(year, month, 1).toISOString();
    const end = new Date(year, month + 1, 0, 23, 59, 59).toISOString();
    fetch(`${API}/api/activities/athlete/${athleteId}?start=${start}&end=${end}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(r => r.json())
    .then(data => setActivities(Array.isArray(data) ? data : []))
    .catch(() => setActivities([]));
  }, [athleteId, year, month]);

  const firstDay = new Date(year, month, 1);
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const startDow = (firstDay.getDay() + 6) % 7;

  const actsByDay = {};
  activities.forEach(a => {
    const d = new Date(a.date || a.start);
    const day = d.getDate();
    if (!actsByDay[day]) actsByDay[day] = [];
    actsByDay[day].push(a);
  });

  const maxTSS = Math.max(...Object.values(actsByDay).map(acts =>
    acts.reduce((s,a) => s+(a.tss||a.completed?.tss||0),0)
  ), 1);

  const prevMonth = () => { if(month===0){setMonth(11);setYear(y=>y-1);}else setMonth(m=>m-1); };
  const nextMonth = () => { if(month===11){setMonth(0);setYear(y=>y+1);}else setMonth(m=>m+1); };

  const reloadActivities = () => {
    if (!athleteId) return;
    const token = localStorage.getItem('token');
    const start = new Date(year, month, 1).toISOString();
    const end = new Date(year, month + 1, 0, 23, 59, 59).toISOString();
    fetch(`${API}/api/activities/athlete/${athleteId}?start=${start}&end=${end}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => r.json())
    .then(data => setActivities(Array.isArray(data) ? data : []))
    .catch(() => {});
  };

  const handleClick = (act) => {
    setSelected({ id: act._id, _id: act._id, type: act.type, title: act.title, date: act.start || act.date, selectedDate: act.start || act.date, completed: act.completed, planned: act.planned, metrics: act.metrics, description: act.description });
    setShowModal(true);
  };

  const today = new Date();

  return (
    <div style={{ background:'#fff', borderRadius:12, border:'0.5px solid #e5e7eb', overflow:'hidden' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', borderBottom:'1px solid #f0f0f0' }}>
        <button onClick={prevMonth} style={{ border:'1px solid #d1d5db', background:'#fff', borderRadius:6, padding:'5px 14px', cursor:'pointer', fontSize:18, fontWeight:700, color:'#374151', lineHeight:1 }}>&#8249;</button>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <select value={month} onChange={e=>setMonth(Number(e.target.value))}
            style={{ border:'1px solid #d1d5db', borderRadius:6, padding:'4px 8px', fontSize:13, fontWeight:600, color:'#111827', cursor:'pointer', background:'#fff' }}>
            {MONTHS.map((m,i) => <option key={i} value={i}>{m}</option>)}
          </select>
          <select value={year} onChange={e=>setYear(Number(e.target.value))}
            style={{ border:'1px solid #d1d5db', borderRadius:6, padding:'4px 8px', fontSize:13, fontWeight:600, color:'#111827', cursor:'pointer', background:'#fff' }}>
            {Array.from({length:15},(_,i)=>2017+i).map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          <button onClick={() => { setMonth(now.getMonth()); setYear(now.getFullYear()); }}
            style={{ border:'1px solid #d1d5db', background:'#fff', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:12, color:'#374151' }}>{lng === 'en' ? 'Today' : 'Hoy'}</button>
        </div>
        <button onClick={nextMonth} style={{ border:'1px solid #d1d5db', background:'#fff', borderRadius:6, padding:'5px 14px', cursor:'pointer', fontSize:18, fontWeight:700, color:'#374151', lineHeight:1 }}>&#8250;</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', background:'#f8fafc' }}>
        {DAYS.map(d => (
          <div key={d} style={{ textAlign:'center', fontSize:10, fontWeight:700, color:'#6b7280', padding:'6px 0' }}>{d}</div>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:1, background:'#f0f0f0' }}>
        {Array(startDow).fill(null).map((_,i) => (
          <div key={`e${i}`} style={{ background:'#fafafa', minHeight:90 }} />
        ))}
        {Array.from({length:daysInMonth},(_,i)=>i+1).map(day => {
          const acts = actsByDay[day] || [];
          // eslint-disable-next-line no-unused-vars
          const dayTSS = acts.reduce((s,a)=>s+(a.tss||a.completed?.tss||0),0);
          const isToday = today.getDate()===day && today.getMonth()===month && today.getFullYear()===year;
          return (
            <div key={day} style={{ background:'#fff', minHeight:90, padding:'4px', position:'relative', borderTop: isToday?'2px solid #f7941d':'none' }}>
              <span onClick={() => { setCreateDate(new Date(year, month, day)); setShowCreate(true); }}
                style={{ fontSize:11, color:isToday?'#f7941d':'#374151', fontWeight:isToday?700:400, display:'block', marginBottom:3, cursor:'pointer' }}>{day}</span>
              {acts.slice(0,3).map((a,i) => {
                const color = SPORT_COLORS[a.type] || '#6b7280';
                const tss = a.tss || a.completed?.tss || 0;
                return (
                  <div key={i} onClick={() => handleClick(a)}
                    style={{ marginBottom:2, padding:'2px 4px', borderRadius:3, background:color+'15', borderLeft:`3px solid ${color}`, cursor:'pointer' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <img src={SPORT_ICONS_IMG[a.type]||SPORT_ICONS_IMG.otro} alt={a.type} width="16" height="16" style={{objectFit:'contain'}} />
                    </div>
                    {tss > 0 && <div style={{ fontSize:9, color, marginTop:1 }}>TSS {tss.toFixed(0)}</div>}
                  </div>
                );
              })}
              {acts.length > 3 && <div style={{ fontSize:9, color:'#9ca3af' }}>+{acts.length-3}</div>}

            </div>
          );
        })}
      </div>

      <div style={{ padding:'8px 16px', display:'flex', gap:12, flexWrap:'wrap', borderTop:'1px solid #f0f0f0', alignItems:'center' }}>
        {Object.entries(SPORT_COLORS).slice(0,5).map(([s,c]) => (
          <span key={s} style={{ fontSize:10, color:c, fontWeight:600 }}>&#9632; {SPORT_LABELS[lng][s] || s}</span>
        ))}
        <span style={{ fontSize:10, color:'#6b7280', marginLeft:'auto' }}>
          {activities.length} {lng === 'en' ? 'activities' : 'actividades'}
        </span>
      </div>

      {showCreate && (
        <LABCreateActivityModal
          show={showCreate}
          onHide={() => setShowCreate(false)}
          date={createDate}
          athleteId={athleteId}
          onSaved={() => {
            setShowCreate(false);
            const token = localStorage.getItem('token');
            const start = new Date(year, month, 1).toISOString();
            const end = new Date(year, month + 1, 0, 23, 59, 59).toISOString();
            fetch(`${API}/api/activities/athlete/${athleteId}?start=${start}&end=${end}`, {
              headers: { Authorization: `Bearer ${token}` }
            }).then(r => r.json()).then(data => setActivities(Array.isArray(data) ? data : []));
          }}
        />
      )}
      {showModal && selected && (
        <LABActivityModal
          show={showModal}
          onHide={() => { setShowModal(false); reloadActivities(); }}
          activityType={selected}
          onDelete={() => { setShowModal(false); reloadActivities(); }}
        />
      )}
    </div>
  );
}
